import { useEffect, useState } from "react";
import { useFirestore, useUser } from "reactfire";
import { doc, onSnapshot } from "firebase/firestore";
import { User } from "../models/user";

export const useMe = (): User => {
  const { status: userStatus, data: user } = useUser();
  const firestore = useFirestore();
  const [profile, setProfile] = useState<Record<string, any>>({});
  const [profileLoaded, setProfileLoaded] = useState(false);

  useEffect(() => {
    if (!user?.uid) {
      setProfile({});
      setProfileLoaded(false);
      return;
    }

    const ref = doc(firestore, "users", user.uid);
    const unsub = onSnapshot(
      ref,
      (snapshot) => {
        setProfile(snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : {});
        setProfileLoaded(true);
      },
      () => {
        setProfile({});
        setProfileLoaded(true);
      }
    );

    return () => unsub();
  }, [firestore, user?.uid]);

  if (userStatus !== "success" || !user) {
    return {
      profileLoaded: false,
    } as any;
  }

  const me = {
    ...user,
    ...profile,
    profileLoaded,
  };

  return me as any;
};
